var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UiButton", {
        attrs: {
          buttonText: _vm.noteButtonText,
          variant: _vm.buttonVariant,
          size: "lg",
        },
        on: {
          click: function ($event) {
            _vm.modalShown = true
          },
        },
      }),
      _vm.modalShown
        ? _c("ApplicationNoteModal", {
            attrs: {
              currentUserId: _vm.currentUserId,
              applicationId: _vm.applicationId,
              jobTitle: _vm.jobTitle,
              companyName: _vm.companyName,
              location: _vm.location,
              employmentType: _vm.employmentType,
              duration: _vm.duration,
              postedDate: _vm.postedDate,
              description: _vm.description,
              skills: _vm.skills,
              industries: _vm.industries,
              postingId: _vm.postingId,
              attachedDocumentId: _vm.attachedDocumentId,
              actionButtonText: _vm.actionButtonText,
            },
            on: {
              close: function ($event) {
                _vm.modalShown = false
              },
              updated: _vm.onUpdate,
              fileUploaded: _vm.onAttachNewFile,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }